/**
 * Color constants for the Doppler UI application
 */
export const Colors = {
	// Primary brand colors
	PRIMARY: "#004C4B",
	PRIMARY_LIGHT: "rgba(0,76,75,0.1)",
	PRIMARY_MEDIUM: "rgba(0,76,75,0.5)",
	PRIMARY_BG: "rgba(0,76,75,0.05)",
	PRIMARY_BORDER: "rgba(0,76,75,0.3)",

	// Text colors
	TEXT_PRIMARY: "#0F0F0F",
	TEXT_SECONDARY: "#4B5563",
	TEXT_GRAY: "#808080",
	TEXT_STRONG: "#1F2937",

	// Background colors
	BACKGROUND_WHITE: "#FFFFFF",
	BACKGROUND_GRAY: "#EAEAEA",
	BACKGROUND_OVERLAY: "rgba(0,0,0,0.5)",

	// Border colors
	BORDER_LIGHT: "#D4D4D4",

	// Status colors
	SUCCESS: "#004C4B",
	ERROR: "#EF4444",

	// Neutral colors
	WHITE: "#FFFFFF",
	BLACK: "#000000",
} as const;

export type ColorKey = keyof typeof Colors;
